module.exports = __webpack_public_path__ + "static/media/1017023.65075664.jpg";